// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideshowStyles } from "@awc/Overrides/Widgets/Basic/Slideshow";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.slideOverlayWrapper = {
    css: css`
        position: absolute;
        left: 0;
        top: 0;
    `,
};

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        width: 100%;
        margin-top: 16px;
        ${xScreen("lte", "xs")} {
            &.hide-on-mobile {
                display: none;
            }
        }
    `,
};

slideshowStyles.dotButton = {
    css: css`
        border: 1px solid ${color("common.ui3")};
        background: ${color("common.ui3")};
        border-radius: 100%;
        width: 12px;
        height: 12px;
        padding: 0;
        min-height: unset;
        &:hover,
        &:active {
            border: 1px solid ${color("common.ui9")};
            background: ${color("common.ui9")};
        }
    `,
};

slideshowStyles.iconProps = {
    ...{ width: 19, height: 16 },
    color: "text.main",
};

slideshowStyles.prevArrowWrapper = {
    css: css`
        &.default {
            position: absolute;
            z-index: 1;
            top: 50%;
            margin-top: -42px;
            padding: 0;
            background-color: ${color("common.ui7", 0.75)};
            &:hover {
                background-color: ${color("common.ui7", 0.5)};
            }
        }

        &.mobile {
            display: none;
        }

        ${xScreen("lte", "xs")} {
            &.default {
                display: none;
            }
            &.mobile {
                display: block;
                margin-right: 8px;
            }
        }
    `,
};

slideshowStyles.nextArrowWrapper = {
    css: css`
        &.default {
            position: absolute;
            z-index: 1;
            top: 50%;
            margin-top: -42px;
            right: 0;
            padding: 0;
            background-color: ${color("common.ui7", 0.75)};
            &:hover {
                background-color: ${color("common.ui7", 0.5)};
            }
        }

        &.mobile {
            display: none;
        }

        ${xScreen("lte", "xs")} {
            &.default {
                display: none;
            }
            &.mobile {
                display: block;
                margin-left: 8px;
            }
        }
    `,
};

slideshowStyles.iconProps = {
    height: 24,
    width: 12,
    css: css`
        min-height: initial;
        ${xScreen("lte", "xs")} {
            &&& {
                &,
                & > svg {
                    color: ${color("common.ui7", 0.75)};
                    width: 16px;
                    height: 16px;
                }
            }
        }
    `,
} as any;

slideshowStyles.slideNumber = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
    css: css`
        position: absolute;
        top: 10px;
        left: 10px;
    `,
};

slideshowStyles.slideNumberPart = {
    weight: fontConfig.weight.bold,
    css: css`
        padding-inline: 5px;
    `,
};

slideshowStyles.prevArrowButton = slideshowStyles.nextArrowButton = {
    css: css`
        background: none;
        border: 0;
        padding: 25px 8px 25px 9px;
        &:hover {
            background: none;
        }
        min-height: unset;
    `,
};
